import { useState, useEffect } from "react";
import css from "./lesson.module.css";
import LessonInfo from "./lessonInfo";
import WrapVideo from "./wrapVideo";
import WordsComponent from "./wordsComponent";
import Discuss from "./discuss";
import QuestionCardExample from "./newTestings/QuestionCardExample";
import Dialogues from "./PracticeDialogues/Dialogues";
import CompletionScreen from "./CompletionScreen";
import FailedLessonScreen from "./FailedLessonScreen";
import { toggleVideoFavorite, getFavoriteStatus } from '../../lib/favoriteApi';
import { getLanguageLevelById } from "../../lib/getLanguageLevels";
import { getVideoCategories } from "../../lib/videoCategoryApi";
import { useTranslation } from "react-i18next";
import like from '../../img/like.png';
import likeOff from '../../img/likeOff.png';
import { useNavigate, useParams } from "react-router-dom";
import ReportModal from "./ReportModal";
import reportCss from "./reportModal.module.css";

const LessonBlock = ({ lesson, authUser }) => {
  const { t } = useTranslation();
  const { id } = useParams();

  const [videoP, setVideoP] = useState(true);
  const [learnWords, setLearnWords] = useState(false);
  const [videoQ, setVideoQ] = useState(false);
  const [dialogues, setDialogues] = useState(false);
  const [showCompletion, setShowCompletion] = useState(false);
  const [selectedButton, setSelectedButton] = useState("speak");
  const [isLiked, setIsLiked] = useState(false);
  const [favoriteId, setFavoriteId] = useState(null);
  const [languageLevel, setLanguageLevel] = useState("");
  const [levels, setLevels] = useState([]);
  const [isTogglingFavorite, setIsTogglingFavorite] = useState(false);
  const [categories, setCategories] = useState([]);
  const [videos, setVideos] = useState(authUser?.videoLessonsAll || []);
  const [currentStep, setCurrentStep] = useState(1); // Track current step (1-4)
  const [quizScore, setQuizScore] = useState(0);
  const [speakingScore, setSpeakingScore] = useState(0);
  const [showFailedLesson, setShowFailedLesson] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const navigate = useNavigate();
  const [levelStyles, setLevelStyles] = useState({
    bgColor: "#e0e0e0",
    textColor: "#000",
    fullName: "Unknown Level",
    order: "-",
  });

  const totalSteps = 4;
  
  // Step data for guidance
  const stepData = [
    {
      guidanceLabel: 'What to do now',
      guidanceTitle: 'Дивись відео',
      guidanceSub: 'Перегляньте короткий діалог з реального життя, а потім переходьте до слів.',
      ctaText: 'Далі до Words',
      iconSvg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/>
          <path d="M5 3v4"/><path d="M19 17v4"/><path d="M3 5h4"/><path d="M17 19h4"/>
        </svg>
      )
    },
    {
      guidanceLabel: 'What to do now',
      guidanceTitle: 'Вивчай слова',
      guidanceSub: 'Вивчіть нові слова з відео, потім натисніть «Далі».',
      ctaText: 'Далі до Quiz',
      iconSvg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/>
        </svg>
      )
    },
    {
      guidanceLabel: 'What to do now',
      guidanceTitle: 'Перевір знання',
      guidanceSub: 'Перевірте своє розуміння, потім натисніть «Далі».',
      ctaText: 'Далі до Speaking',
      iconSvg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/>
        </svg>
      )
    },
    {
      guidanceLabel: 'What to do now',
      guidanceTitle: 'Практикуй діалог',
      guidanceSub: 'Розмовляйте з AI англійською. Це останній крок уроку!',
      ctaText: '',
      iconSvg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/>
          <path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" x2="12" y1="19" y2="22"/>
        </svg>
      )
    }
  ];

  const currentStepData = stepData[currentStep - 1] || stepData[0];

  const levelMapping = {
    "pre-A1": {
      fullName: "Pre-Beginner",
      order: 0,
      bgColor: "#c8e6c9",
      textColor: "#1b5e20",
      name: "pre-A1",
    },
    A1: {
      fullName: "Beginner",
      order: 1,
      bgColor: "#e8f5e9",
      textColor: "#2e7d32",
      name: "A1",
    },
    A2: {
      fullName: "Elementary",
      order: 2,
      bgColor: "#fff3e0",
      textColor: "#f57c00",
      name: "A2",
    },
    B1: {
      fullName: "Intermediate",
      order: 3,
      bgColor: "#e3f2fd",
      textColor: "#1565c0",
      name: "B1",
    },
    B2: {
      fullName: "Upper-Intermediate",
      order: 4,
      bgColor: "#ede7f6",
      textColor: "#673ab7",
      name: "B2",
    },
    C1: {
      fullName: "Advanced",
      order: 5,
      bgColor: "#ffebee",
      textColor: "#d32f2f",
      name: "C1",
    },
    C2: {
      fullName: "Proficiency",
      order: 6,
      bgColor: "#fce4ec",
      textColor: "#c2185b",
      name: "C2",
    },
  };

  //console.log(authUser)

  // Check lesson completion status dynamically
  useEffect(() => {
    if (authUser?.videoLessonsAll) {
      setVideos(authUser.videoLessonsAll);
    }
  }, [authUser?.videoLessonsAll]);

  // Function to check and update completion status
  const checkAndUpdateCompletion = async () => {
    if (!authUser?.isAuthenticated || !lesson?.id) return;
    
    try {
      console.log('🔄 Checking lesson completion status...');
      console.log('Current lesson ID:', lesson.id);
      console.log('Current lesson.video.id:', lesson.video?.id);
      
      // Use the global refreshAuthUser function if available, otherwise fetch directly
      let updatedVideos = [];
      
      if (window.refreshAuthUser) {
        console.log('Using global refreshAuthUser...');
        const freshAuthUser = await window.refreshAuthUser();
        updatedVideos = freshAuthUser?.videoLessonsAll || [];
      } else {
        console.log('Fetching directly from API...');
        // Fallback: fetch directly
        const response = await fetch('/api/v1/user-profile/current', {
          credentials: 'include'
        });
        
        if (response.ok) {
          const userData = await response.json();
          updatedVideos = userData.videoLessonsAll || [];
        }
      }
      
      console.log('📦 Fetched videos from backend:', updatedVideos.length, 'videos');
      
      if (updatedVideos.length === 0) {
        console.warn('⚠️ No videos returned from backend');
        return;
      }
      
      setVideos(updatedVideos);
      
      // Try to find the current video by matching lesson.id with video.id in the array
      // The videoLessonsAll array contains objects with structure: { id: X, video: { id: Y }, ... }
      // We need to match lesson.id (from URL) with the video.id field
      let currentVideo = updatedVideos.find((v) => v.video?.id === lesson.id);
      
      // Fallback: if not found, try matching with the top-level id
      if (!currentVideo) {
        currentVideo = updatedVideos.find((v) => v.id === lesson.id);
      }
      
      console.log('Found currentVideo:', currentVideo);
      
      if (!currentVideo) {
        console.warn('⚠️ No video data found for lesson:', lesson.id);
        console.warn('Available video.id values:', updatedVideos.map(v => v.video?.id));
        console.warn('Available top-level id values:', updatedVideos.map(v => v.id));
        return;
      }
      
      const isCompleted = currentVideo?.is_completed || false;
      
      console.log('✅ Completion check result:', {
        lessonId: lesson.id,
        isCompleted,
        videoLessonId: currentVideo.id,
        videoId: currentVideo.video?.id
      });
      
      // Determine if they passed the 70% thresholds
      const passedQuiz = quizScore >= 7; // assuming 0-10 scale
      const passedSpeaking = speakingScore >= 70; // assuming 0-100 scale

      if (isCompleted && !showCompletion && !showFailedLesson) {
        // If completed from backend but they just finished and failed locally
        if (currentStep === 4 && (!passedQuiz || !passedSpeaking)) {
            console.log('❌ Lesson failed (under 70%). Showing failed screen...');
            setShowFailedLesson(true);
            setVideoP(false);
            setLearnWords(false);
            setVideoQ(false);
            setDialogues(false);
        } else {
            console.log('🎉 Lesson completed! Showing completion screen...');
            setShowCompletion(true);
            setVideoP(false);
            setLearnWords(false);
            setVideoQ(false);
            setDialogues(false);
        }
      }
    } catch (error) {
      console.error('❌ Error checking completion status:', error);
    }
  };

  // Initial completion check on mount
  useEffect(() => {
    const checkCompletion = () => {
      // Try to find the current video by matching lesson.id with video.id in the array
      let currentVideo = videos.find((v) => v.video?.id === lesson?.id);
      
      // Fallback: if not found, try matching with the top-level id
      if (!currentVideo) {
        currentVideo = videos.find((v) => v.id === lesson?.id);
      }
      
      const isCompleted = currentVideo?.is_completed || false;
      
      console.log('Initial completion check:', {
        lessonId: lesson?.id,
        foundVideo: !!currentVideo,
        isCompleted
      });
      
      if (isCompleted) {
        // On initial load or when lesson is completed, show completion screen
        setShowCompletion(true);
        setVideoP(false);
        setLearnWords(false);
        setVideoQ(false);
        setDialogues(false);
      }
    };

    if (lesson && videos.length > 0) {
      checkCompletion();
    }
  }, [lesson, videos]);

  // Fetch lesson data and categories
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch categories
        const categoriesData = await getVideoCategories();
        setCategories(categoriesData.results);

        // Fetch language level and set styles
        if (lesson?.video?.languageLevel) {
          const level = await getLanguageLevelById(lesson.video.languageLevel);
          setLanguageLevel(level.name);
          if (levelMapping[level.name]) {
            setLevelStyles(levelMapping[level.name]);
          }
        }

        // Fetch favorite status
        if (lesson?.video?.id) {
          const { isFavorited, favoriteId: favoriteIdValue } = await getFavoriteStatus(lesson.video.id);
          setIsLiked(isFavorited);
          setFavoriteId(favoriteIdValue);
        }
      } catch (error) {
        console.error("Error fetching lesson data:", error);
        // Fallback to lesson data if API call fails
        if (lesson) {
          const isFavorited = lesson.is_favorited || false;
          const favoriteIdValue = lesson.favorite_id || null;
          setIsLiked(isFavorited);
          setFavoriteId(favoriteIdValue);
        }
      }
    };

    if (lesson) {
      fetchData();
    }
  }, [lesson]);

  const handleSelect = (button) => {
    setSelectedButton(button);
  };

  // Expose handlers globally for Dialogues component to switch views
  useEffect(() => {
    window.lessonInfoHandlers = {
      handleSelect: (button) => {
        let targetIndex = -1;
        let newStep = currentStep;
        
        if (button === 'words') {
          setShowCompletion(false);
          setVideoP(false);
          setLearnWords(true);
          setDialogues(false);
          setVideoQ(false);
          setSelectedButton("learn");
          targetIndex = 1; // Second button (Study Words)
          newStep = 2;
        } else if (button === 'speak') {
          setShowCompletion(false);
          setVideoP(true);
          setLearnWords(false);
          setVideoQ(false);
          setDialogues(false);
          setSelectedButton("speak");
          targetIndex = 0; // First button (Watch Video)
          newStep = 1;
        } else if (button === 'test') {
          setShowCompletion(false);
          setVideoP(false);
          setLearnWords(false);
          setVideoQ(true);
          setDialogues(false);
          setSelectedButton("discuss");
          targetIndex = 2; // Third button (Check Understanding)
          newStep = 3;
        } else if (button === 'dialogue') {
          setShowCompletion(false);
          setVideoP(false);
          setLearnWords(false);
          setVideoQ(false);
          setDialogues(true);
          setSelectedButton("none");
          targetIndex = 3; // Fourth button (Practice Dialogues)
          newStep = 4;
        }
        
        setCurrentStep(newStep);
        
        // Update active state for buttons using data attribute
        if (targetIndex >= 0) {
          setTimeout(() => {
            const choiceWraps = document.querySelectorAll('[data-choice-index]');
            choiceWraps.forEach((el) => {
              const index = parseInt(el.getAttribute('data-choice-index'));
              if (index === targetIndex) {
                el.classList.add('active');
              } else {
                el.classList.remove('active');
              }
            });
          }, 100);
        }
      }
    };

    return () => {
      delete window.lessonInfoHandlers;
    };
  }, [currentStep]);

  // Function to advance to next step
  const advanceStep = () => {
    if (currentStep < 4) {
      const nextStep = currentStep + 1;
      setCurrentStep(nextStep);
      
      // Update view based on next step
      if (nextStep === 1) {
        setVideoP(true);
        setLearnWords(false);
        setVideoQ(false);
        setDialogues(false);
        setShowCompletion(false);
        setSelectedButton("speak");
      } else if (nextStep === 2) {
        setVideoP(false);
        setLearnWords(true);
        setVideoQ(false);
        setDialogues(false);
        setShowCompletion(false);
        setSelectedButton("learn");
      } else if (nextStep === 3) {
        setVideoP(false);
        setLearnWords(false);
        setVideoQ(true);
        setDialogues(false);
        setShowCompletion(false);
        setSelectedButton("discuss");
      } else if (nextStep === 4) {
        setVideoP(false);
        setLearnWords(false);
        setVideoQ(false);
        setDialogues(true);
        setShowCompletion(false);
        setSelectedButton("none");
      }
      
      // Update active state for buttons
      setTimeout(() => {
        const choiceWraps = document.querySelectorAll('[data-choice-index]');
        choiceWraps.forEach((el, i) => {
          if (i === nextStep - 1) {
            el.classList.add('active');
          } else {
            el.classList.remove('active');
          }
        });
      }, 100);
    }
  };

  // Expose advanceStep globally for child components
  useEffect(() => {
    window.advanceStep = advanceStep;
    
    return () => {
      delete window.advanceStep;
    };
  }, [currentStep, videoP, learnWords, videoQ, dialogues]);

  const handleRegister = () => {
    // Navigate to registration page
    window.location.href = "/signup";
  };

  const findParentCategory = (categoryId) => {
    const category = categories.find(cat => cat.id === categoryId);
    if (!category) return null;

    if (category.parent === null) {
      return category;
    }

    return categories.find(cat => cat.id === category.parent);
  };

  const getCategoryIcon = (categoryId) => {
    const parentCategory = findParentCategory(categoryId);
    if (!parentCategory) return '🌐';

    const name = parentCategory.name?.toLowerCase() || '';

    // Check for more specific categories first (order matters!)
    if (name.includes('talk') || name.includes('dialogue') || name.includes('діалог') || name.includes('розмов') || name.includes('спілкування') || name.includes('rozmawiać') || name.includes('dialog') || name.includes('socializ')) return '🗣️';
    if (name.includes('all') || name.includes('всі') || name.includes('wszystkie')) return '🌐';
    if (name.includes('travel') || name.includes('подорож') || name.includes('podróż')) return '✈️';
    if (name.includes('work') || name.includes('робот') || name.includes('praca') || name.includes('business') || name.includes('бізнес')) return '💼';
    if (name.includes('education') || name.includes('освіт') || name.includes('edukacja') || name.includes('learn')) return '📚';
    if (name.includes('health') || name.includes('здоров') || name.includes('zdrowie')) return '❤️';
    if (name.includes('news') || name.includes('новин') || name.includes('wiadomości') || name.includes('tech') || name.includes('технолог')) return '📱';
    if (name.includes('leisure') || name.includes('дозвілля') || name.includes('rozrywka') || name.includes('entertainment') || name.includes('розваг')) return '🎮';
    if (name.includes('daily') || name.includes('щоден') || name.includes('codzienn')) return '📅';

    return '🌐';
  };

  const getCategoryName = (categoryId) => {
    const category = categories.find((cat) => cat.id === categoryId);
    return category ? category.name : "Unknown Category";
  };

  const handleFavoriteToggle = async () => {
    if (isTogglingFavorite || !lesson?.video?.id) return; // Prevent multiple clicks and ensure video id exists
    setIsTogglingFavorite(true);

    // Store previous state for rollback
    const previousIsLiked = isLiked;
    const previousFavoriteId = favoriteId;

    // Optimistic update
    setIsLiked(!isLiked);

    try {
      const response = await toggleVideoFavorite(lesson.video.id, favoriteId, isLiked);

      if (!isLiked) {
        // Adding to favorites - response should contain the new favorite ID
        setFavoriteId(response.id);
        console.log('Added to favorites with ID:', response.id);
      } else {
        // Removing from favorites
        setFavoriteId(null);
        console.log('Removed from favorites');
      }

      // Fetch updated favorite status to ensure consistency
      const { isFavorited, favoriteId: newFavoriteId } = await getFavoriteStatus(lesson.video.id);
      setIsLiked(isFavorited);
      setFavoriteId(newFavoriteId);
      console.log('Favorite status updated successfully');
    } catch (error) {
      console.error('Error toggling favorite:', error);
      // Revert optimistic update on error
      setIsLiked(previousIsLiked);
      setFavoriteId(previousFavoriteId);
      // Show user-friendly error message
      alert(t('Failed to update favorite status. Please try again.'));
    } finally {
      setIsTogglingFavorite(false);
    }
  };

  return (
    <div className={css.wrapAllN}>
      
      {currentStep !== 4 && (
        <>
          {/* Design 27 — Compact Top Bar */}
          <div className={css.d27topbar}>
            <div className={css.d27left}>
              <div className={css.d27step}>{t("Step")} {currentStep} {t("of")} 4</div>
              <div className={css.d27info}>
                <h2 className={css.d27title}>{t(currentStepData.guidanceTitle)}</h2>
                <p className={css.d27desc}>{t(currentStepData.guidanceSub)}</p>
              </div>
            </div>
            <div className={css.d27right}>
              {(!authUser || !authUser.isAuthenticated) && (
                <button className={css.d27regBtn} onClick={() => navigate('/signup')}>
                  {t("Зберегти прогрес")}
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
                </button>
              )}
              {currentStep < 4 && (
                <button className={css.d27btnNext} onClick={() => window.advanceStep && window.advanceStep()}>
                  {t(currentStepData.ctaText || 'Далі')}
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
                </button>
              )}
            </div>
          </div>
        </>
      )}

      {/* Target for Dialogues Header (Design 29) */}
      <div id="dialogue-header-portal-target"></div>

      {/* Main Container */}
      <div className={css.mainContainer}>
        {/* Lesson Content */}
        <div className={css.lessonContent}>
          {/* Video/Content Area */}
          <div className={css.leftWrap}>
            {showFailedLesson && (
                <FailedLessonScreen 
                  lesson={{ ...lesson, quizScore: quizScore * 10, speakingScore: speakingScore }} 
                  authUser={authUser}
                  onRepeat={() => {
                    setShowFailedLesson(false);
                    setVideoP(true);
                    setLearnWords(false);
                    setVideoQ(false);
                    setDialogues(false);
                    setCurrentStep(1);
                  }}
                />
            )}

            {showCompletion && !showFailedLesson && (
              <CompletionScreen 
                lesson={lesson} 
                authUser={authUser}
              />
            )}
            {!showCompletion && !showFailedLesson && videoP && <WrapVideo lesson={lesson} authUser={authUser} videos={videos} setVideos={setVideos} onActivityComplete={checkAndUpdateCompletion} />}
            {!showCompletion && !showFailedLesson && learnWords && (
              <div className={css.wrWhereW}>
                <WordsComponent lesson={lesson} onActivityComplete={checkAndUpdateCompletion} />
              </div>
            )}
            {!showCompletion && !showFailedLesson && videoQ && (
              <div style={{width:'100%', flex:1, overflow:'auto'}}>
                <QuestionCardExample
                  questions={lesson.video.questions}
                  onActivityComplete={(score) => {
                    if (score !== undefined) setQuizScore(score);
                    checkAndUpdateCompletion();
                  }}
                  lessonId={lesson?.id}
                  videoLessonId={lesson?.video?.id}
                />
              </div>
            )}
            {!showCompletion && !showFailedLesson && dialogues && (
              <div style={{width:'100%', flex:1, overflow:'auto'}}>
                <Dialogues 
                  lesson={lesson} 
                  authUser={authUser}
                  onActivityComplete={(score) => {
                    if (score !== undefined) setSpeakingScore(score);
                    checkAndUpdateCompletion();
                  }}
                />
              </div>
            )}
            
            {/* Report Problem Link */}
            {!showCompletion && !showFailedLesson && (
              <div className={reportCss.rptLink} onClick={() => setShowReportModal(true)}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>
                {t('reportProblemText', 'Проблема з уроком? Повідомити')}
              </div>
            )}
          </div>
        </div>

        {/* Sidebar */}
        <div className={css.rightWrap}>
          <LessonInfo
            handleSelect={handleSelect}
            lesson={lesson}
            setLearnWords={setLearnWords}
            setVideoP={setVideoP}
            setSelectedButton={setSelectedButton}
            selectedButton={selectedButton}
            setVideoQ={setVideoQ}
            videoQ={videoQ}
            dialogues={dialogues}
            setDialogues={setDialogues}
            isCompletionShown={showCompletion}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            authUser={authUser}
          />
        </div>
      </div>

      {/* Report Modal */}
      <ReportModal 
        isOpen={showReportModal} 
        onClose={() => setShowReportModal(false)} 
        lesson={lesson} 
      />
    </div>
  );
};
export default LessonBlock;
